import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';
import { path } from 'ramda';
import MessageListIkon, {
  RutinEnum,
} from '../Leverantor/ObjektVyer/LeverantorFaktura/Components/MessageListIkon';
import FakturaDokumentAddComp from '../Leverantor/ObjektVyer/FakturaDok/Components/FakturaDokumentAddComp';
import { isImageExtension } from '../../../Components/Documents/Documents';
import DokumentViewIkon from '../../../Components/DokumentViewIkon';
import DokumentDownloadIkon from '../../../Components/DokumentDownloadIkon';
import {
  TEDEKBokforderMinBokforderStatusEnum,
  TEDEKBokforderTYPEnum,
} from '../../../globalQueryTypes';
import BokforderMinStatusComp from './ObjektVyer/Bokforder/Components/BokforderMinStatusComp/BokforderMinStatusComp';
import BokforderTypComp from './ObjektVyer/Bokforder/Components/BokforderTypComp/BokforderTypComp';
import { getBokforderTypeFromSearchParams } from './ObjektVyer/Bokforder/Utils/BokforderUtils';

const EKBusinessConfig = initConst<IBusinessConfigs>(() => ({
  EKBokfjournal: {
    defaultColumns: [
      // { attributeDef: 'BOKF_AR', caption: 'År' },
      // { attributeDef: 'Period', caption: 'Period' },
      // { attributeDef: 'BENAMNING', caption: 'Bokföringsgrupp' },
      { attributeDef: 'JOURNAL_NR', caption: 'Journalnr', header: true },
      { attributeDef: 'SKAPAD_DATUM', caption: 'Skapad' },
      { attributeDef: 'STATUS', caption: 'Status' },
      { attributeDef: 'OVERFORD_DATUM', caption: 'Definitivbokförd' },
      { attributeDef: 'TEXT', caption: 'Text' },
    ],
  },
  EKBokfver: {
    attributes: { DATUM: { tableDefaultWidth: 168 } },
    defaultColumns: [
      { attributeDef: 'Journalnr', caption: 'Journalnr', header: true },
      { attributeDef: 'VER_NR', caption: 'Vernr', header: true },
      { attributeDef: 'DATUM', caption: 'Bokf.datum' },
      { attributeDef: 'TEXT', caption: 'Text' },
      { attributeDef: 'Summa_Debet', caption: 'Debet' },
      { attributeDef: 'Summa_Kredit', caption: 'Kredit' },
      { attributeDef: 'Saldo', caption: 'Saldo' },
    ],
  },
  EKAutomatkonteringar: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
    ],
  },
  EKBudgetVer: {
    defaultColumns: [
      { attributeDef: 'TEXT', caption: 'Text', header: true },
      { attributeDef: 'DebetSumma', caption: 'Debet' },
      { attributeDef: 'KreditSumma', caption: 'Kredit' },
    ],
  },
  EKEkonomirapport: {
    defaultColumns: [
      { attributeDef: 'Kategori', caption: 'Kategori', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      { attributeDef: 'RapportTyp', caption: 'Typ' },
      { attributeDef: 'SKAPAD_DATUM', caption: 'Skapad' },
      { attributeDef: 'ANDRAD_DATUM', caption: 'Ändrad' },
      { attributeDef: 'Sidhuvud', caption: 'Sidhuvud' },
    ],
  },
  EKRapportpaket: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      { attributeDef: 'DISTR_SATT', caption: 'Distributionssätt' },
    ],
  },
  EKBokfkontering: {
    defaultSort: [{ attributeName: 'ArVernrRadnr', order: 'asc' }],
    defaultColumns: [
      { attributeDef: 'ArVernrRadnr', header: true },
      // {
      // attributeDef: 'Bokfver.sqlCalcVernr',
      // caption: 'Verifikationsnr',
      // header: true,
      // },
      { attributeDef: 'Bokfver.DATUM', caption: 'Bokf dat' },
      { attributeDef: 'Kontostrang' },
      { attributeDef: 'Kontoben' },
      { attributeDef: 'DEBET', caption: 'Debetbelopp' },
      { attributeDef: 'KREDIT', caption: 'Kreditbelopp' },
      { attributeDef: 'Vertext', caption: 'Verifikationstext' },
      { attributeDef: 'ANTAL', caption: 'Antal' },
      { attributeDef: 'Enhet.ENHET', caption: 'Enhet' },
      // { attributeDef: 'BOKF_AR' },
    ],
  },
  EKFakturahandelse: {
    objectLinksEnabled: true,
    colors: {
      styles: [
        {
          caption: 'Ej definitivbokförd',
          color: 'yellow',
          condition: data =>
            path(
              ['_Associations', 'Bokfverifikationer', 'I_HUVUDBOK'],
              data
            ) === 'NEJ',
          dataDependencies: ['Bokfverifikationer.I_HUVUDBOK'],
        },
        {
          caption: 'Makulering',
          color: 'red',
          condition: data => data?.JUST_BOKF_GRUPP_ID ?? false,
          dataDependencies: ['JUST_BOKF_GRUPP_ID'],
        },
      ],
    },
    defaultColumns: [
      { attributeDef: 'Handelse', caption: 'Typ av händelse', header: true },
      { attributeDef: 'Bokfverifikationer.DATUM', caption: 'Bokf datum' },
      { attributeDef: 'Bokfverifikationer.VER_NR', caption: 'Ver nr' },
      { attributeDef: 'BELOPP', caption: 'Belopp' },
      { attributeDef: 'DATUM', caption: 'Reg datum' },
      { attributeDef: 'ANTECKNING', caption: 'Anteckning' },
      { attributeDef: 'MOMS_BELOPP', caption: 'Varav moms' },
      { attributeDef: 'KundNr', caption: 'Kundnummer' },
      { attributeDef: 'Kundnamn', caption: 'Kund: Namn' },
      { attributeDef: 'Fakturanummer', caption: 'Kund: Fakturanummer' },
      { attributeDef: 'Levfaktura.Leverantorsnr', caption: 'Leverantörsnr' },
      {
        attributeDef: 'Levfaktura.Leverantor.Namn',
        caption: 'Leverantör: Namn',
      },
      {
        attributeDef: 'Levfaktura.FAKTURA_NR',
        caption: 'Leverantör: Fakturanr',
      },
    ],
    defaultSort: [{ attributeName: 'Bokfverifikationer.DATUM', order: 'asc' }],
  },
  EKPersonal: {
    defaultColumns: [
      { attributeDef: 'NAMN', caption: 'Namn', header: true },
      { attributeDef: 'EXTERNT_ANSTNR', caption: 'Anställningsnr' },
      { attributeDef: 'Befattningskod.KOD', caption: 'Befattn kod' },
      { attributeDef: 'Befattningskod.BENAMNING', caption: 'Befattning' },
      { attributeDef: 'LON_TYP', caption: 'Lönetyp' },
      { attributeDef: 'HELTIDSLON', caption: 'Heltidslön' },
      { attributeDef: 'SYSSELSATTNINGSGRAD', caption: 'Sysselsättn' },
      { attributeDef: 'UPPEHALL_FAKTOR', caption: 'Uppeh fakt' },
      { attributeDef: 'ANST_MANAD', caption: 'Anst månad' },
      { attributeDef: 'SLUT_MANAD', caption: 'Slutmånad' },
      { attributeDef: 'FODELSE_AR', caption: 'Födelseår' },
      { attributeDef: 'SEM_DGR', caption: 'Sem dgr' },
      { attributeDef: 'Avtalsomrade.KOD', caption: 'Avtalsområde' },
      { attributeDef: 'Budgetgrupp.BENAMNING', caption: 'Budgetgrupp' },
    ],
  },
  EKGava: {
    defaultColumns: [
      { attributeDef: 'GAVONR', caption: 'Gåvonr', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Omrade', caption: 'Område' },
      { attributeDef: 'RubrikKodBen', caption: 'Rubrik' },
      { attributeDef: 'TYP', caption: 'Typ' },
      { attributeDef: 'Grupp.BENAMNING', caption: 'Gåvogrupp' },
      { attributeDef: 'UtgAterstarPerdatum', caption: 'Återstår per datum' },
    ],
  },

  EKBokforder: {
    attributes: {
      KalkBestnr: { tableMinWidth: 50, tableDefaultWidth: 140 },
      TEXT: { tableMinWidth: 50, tableDefaultWidth: 275 },
      BESTALLD_DATUM: { tableMinWidth: 50, tableDefaultWidth: 160 },
      FardigAttesteradDatum: { tableMinWidth: 50, tableDefaultWidth: 160 },
      AttestantFullnames: { tableMinWidth: 50, tableDefaultWidth: 225 },
      KontrollattestantFullname: { tableMinWidth: 50, tableDefaultWidth: 225 },
      MinBokforderStatus: {
        displayComp: BokforderMinStatusComp,
        hideTooltip: true,
        tableMinWidth: 238,
        tableDefaultWidth: 257,
      },
      TYP: {
        displayComp: BokforderTypComp,
        hideTooltip: true,
        tableMinWidth: 45,
        tableDefaultWidth: { xs: 50, xl: 80 },
      },
    },
    colors: {
      hideLegendColumn: true,
      styles: [
        {
          caption: 'Mina utkast (status Utkast)',
          color: 'pink',
          colorOpacity: 'faded',
          condition: data =>
            data.MinBokforderStatus ===
            TEDEKBokforderMinBokforderStatusEnum.UTKAST,
          dataDependencies: ['MinBokforderStatus'],
        },
        {
          caption:
            'Att hantera av mig (status Ej godkänd av attestant, Att attestera)',
          color: 'lightBlue',
          colorOpacity: 'faded',
          condition: data =>
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.EJ_GODKAND_AV_ATTESTANT ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATT_ATTESTERA ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATT_KONTROLLATTESTERA,
          dataDependencies: ['MinBokforderStatus'],
        },
        {
          caption: 'Ej färdigattesterad bokf.order (status Väntar på attest)',
          color: 'indigo',
          colorOpacity: 'faded',
          condition: data =>
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__HOS_ANNAN_ATTESTANT ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATTESTERAS__HOS_ATTESTANT,

          dataDependencies: ['MinBokforderStatus'],
        },
        {
          caption:
            'Bokf.order som är färdigattesterad, där verifikation är skapad eller definitivbokförd (status Attesterad, Verifikation skapad, Journal bokförd)',
          color: 'darkGreen',
          colorOpacity: 'faded',
          condition: data =>
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__ATTESTANT_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.ATTESTERAD__BESTALLARE_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.KONTROLLATTESTERAD__ATTESTANT_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_SKAPAD__ATTESTANT_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_SKAPAD__BESTALLARE_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.DEFINITIVBOKFORD__ATTESTANT_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.DEFINITIVBOKFORD__BESTALLARE_,
          dataDependencies: ['MinBokforderStatus'],
        },
        {
          caption:
            'Bokf.order som definitivbokförts och korrigerats med ändringsverifikation (status Journal bokförd)',
          color: 'orange',
          colorOpacity: 'faded',
          condition: data =>
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_KORRIGERAD__ATTESTANT_ ||
            data.MinBokforderStatus ===
              TEDEKBokforderMinBokforderStatusEnum.VERIFIKATION_KORRIGERAD__BESTALLARE_,
          dataDependencies: ['MinBokforderStatus'],
        },
      ],
    },
    defaultColumns: [
      {
        attributeDef: 'TYP',
        caption: 'Typ',
        header: true,
        size: 'small',
        hideCaption: true,
      },
      {
        attributeDef: 'KalkBestnr',
        caption: 'Bokf.ordernr',
        header: true,
        size: 'medium',
      },
      { attributeDef: 'TEXT', caption: 'Rubrik', header: true },
      { attributeDef: 'BESTALLD_DATUM' },
      {
        attributeDef: 'Bestallare.Fullname',
        caption: 'Beställd av',
        size: 'medium',
      },
      { attributeDef: 'FardigAttesteradDatum' },
      { attributeDef: 'AttestantFullnames', caption: 'Attesteras av' },
      { attributeDef: 'BOKF_DATUM' },
      { attributeDef: 'MinBokforderStatus', size: 'large' },
      {
        attributeDef: 'KontrollattestantFullname',
        caption: 'Kontrollattesteras av',
      },
    ],
    defaultSort: [
      { attributeName: 'MinBokforderStatus', order: 'asc' },
      { attributeName: 'KalkBestnr', order: 'asc' },
      { attributeName: 'BESTALLD_DATUM', order: 'asc' },
    ],
    listIcons: [
      {
        componentFn: config => (
          <MessageListIkon
            key="MessageListIkon"
            id={config.id || ''}
            hidden={!config.data?.HarMeddelande}
            messages={config.data?._Associations?.Meddelande_All}
            rutin={RutinEnum.BOKFORDER}
          />
        ),
        dataDependencies: [
          'HarMeddelande',
          'Meddelande.MEDDELANDE',
          'Meddelande.DATUM',
          'Meddelande.TID',
          'Meddelande.AvsandareDatumTid',
          'REF_BOKF_AR',
          'REF_VER_NR',
        ],
      },
      {
        componentFn: config => {
          return (
            <DokumentViewIkon
              key="FakturaDokumentViewIkon"
              hidden={!config.data?.HarDokument}
              documents={config.data?._Associations?.Dokument_All}
            />
          );
        },
        dataDependencies: [
          'HarDokument',
          'Dokument.BINARDATA',
          'Dokument.EXTENSION',
          'Dokument.BESKRIVNING',
          'Bestallare.id',
          'STATUS',
        ],
      },
    ],
    dataDependencies: ['Variant', 'Kund.OrgPers._typ'],
    breadcrumbsLabel: location => {
      return getBokforderTypeFromSearchParams(location.search) ===
        TEDEKBokforderTYPEnum.BOKFORINGSORDER
        ? 'bokföringsorder'
        : 'utanordning';
    },
  },
  EKBokforderDokument: {
    addComponent: FakturaDokumentAddComp,
    defaultColumns: [
      { attributeDef: 'BESKRIVNING', header: true },
      { attributeDef: 'EXTENSION' },
      { attributeDef: 'SENAST_ANDRAD' },
      { attributeDef: 'SENAST_ANDRAD_SIGNATUR' },
    ],

    listIcons: [
      {
        componentFn: config => {
          const extension: string = config.data?.EXTENSION?.toLowerCase() ?? '';
          const hidden = !isImageExtension(extension) && extension !== 'pdf';

          return (
            <DokumentViewIkon
              documents={[
                {
                  BINARDATA: config?.data?.BINARDATA,
                  BESKRIVNING: config?.data?.BESKRIVNING,
                  EXTENSION: config?.data?.EXTENSION,
                },
              ]}
              key="FakturaDokumentViewIkon"
              hidden={hidden}
            />
          );
        },
        dataDependencies: ['BINARDATA', 'BESKRIVNING', 'EXTENSION'],
      },
      {
        componentFn: config => (
          <DokumentDownloadIkon
            key="FakturaDokumentDownloadIkon"
            blobId={config.data?.BINARDATA}
            extension={config.data?.EXTENSION}
            fileName={config.data?.BESKRIVNING}
          />
        ),
        dataDependencies: ['BINARDATA'],
      },
    ],
  },
  EKBokforderRad: {
    attributes: {
      TEXT: { tableDefaultWidth: 300 },
    },
    defaultColumns: [],
  },
  EKAnvKontobegr: {
    defaultColumns: [
      { attributeDef: 'Urval.NAME', caption: 'Kodbehörighet', header: true },
      {
        attributeDef: 'Anvandare.NameSign',
        caption: 'Användare',
        header: true,
      },
      { attributeDef: 'FOR_ANALYS', caption: 'För kontoanalys' },
      { attributeDef: 'FOR_RAPPORT', caption: 'För ekonomirapport' },
      { attributeDef: 'FOR_BUDGET', caption: 'För budget' },
      { attributeDef: 'FOR_BOKFORDER', caption: 'Attest bokföringsorder' },
      { attributeDef: 'ATTEST_TYP', caption: 'Attest faktura' },
      {
        attributeDef: 'Kontrollattestratt.Attestant.BENAMNING',
        caption: 'Kontrollattestant',
      },
      {
        attributeDef: 'Attestratt.Attestomrade.KodBenamning',
        caption: 'Attestområde',
      },
      { attributeDef: 'UrvalBeskrivning', caption: 'Urval, beskrivning' },
    ],
  },
  EKTillaggsinfo: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
    ],
  },
  EKMomskod: {
    defaultColumns: [
      { attributeDef: 'MOMS_KOD', caption: 'Momskod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  EKDetaljeringsniva: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
  EKBokforingsmall: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      { attributeDef: 'TEXT', caption: 'Text' },
    ],
  },
  EKGavoGrupp: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      {
        attributeDef: 'VALFRI_VERIFIKATION',
        caption: 'Hämta gåvorad från valfri verifikation',
      },
    ],
  },
  EKGavorubrik: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  EKBudgetgrupp: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
      {
        attributeDef: 'FORDELA_ENLIGT_PERSREG',
        caption: 'Fördela enligt personalregistret',
      },
      { attributeDef: 'UrvalBeskrivning', caption: 'Urval, beskrivning' },
    ],
  },
  EKBudgetkategori: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Budgetkategori', header: true },
    ],
  },
  EKLonetillagg: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'LONEARTER', caption: 'Lönearter' },
      { attributeDef: 'AVTALSENL_SOC_AVG', caption: 'Avtalsenl soc avg' },
      { attributeDef: 'ARBETSGIVARAVGIFT', caption: 'Arbetsg avg' },
      { attributeDef: 'INGAR_I_FAP', caption: 'Ingår i beräkn av FÅP' },
    ],
  },
  EKBefattningskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  EKAvtalsOmrade: {
    defaultColumns: [{ attributeDef: 'KOD', caption: 'Kod', header: true }],
  },
  EKLoneart: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
  EKKontodel: {
    attributes: {
      KontodelBenamning: { tableDefaultWidth: 160 },
    },
    defaultColumns: [
      { attributeDef: 'KONTODEL', caption: 'Kod', header: true },
      { attributeDef: 'BENAMNING', caption: 'Benämning', header: true },
    ],
  },
}));

export default EKBusinessConfig;
